import { render, staticRenderFns } from "./Addbeach.vue?vue&type=template&id=db592676&scoped=true&"
import script from "./Addbeach.vue?vue&type=script&lang=js&"
export * from "./Addbeach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db592676",
  null
  
)

export default component.exports